<script setup lang="ts">
/**
 * The table form of a chart, visually hidden: screen readers get every value
 * the chart draws, row by row, without having to hover. The chart's SVG itself
 * is hidden from assistive technology.
 */
defineProps<{
  caption?: string;
  /** Column headings (first column = row heading). */
  columns: readonly string[];
  rows: readonly { key: string | number; cells: readonly string[] }[];
}>();
</script>

<template>
  <table class="nx-chart-table">
    <caption v-if="caption">{{ caption }}</caption>
    <thead>
      <tr>
        <th v-for="(c, i) in columns" :key="i" scope="col">{{ c }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in rows" :key="row.key">
        <template v-for="(cell, i) in row.cells" :key="i">
          <th v-if="i === 0" scope="row">{{ cell }}</th>
          <td v-else>{{ cell }}</td>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
.nx-chart-table {
  position: absolute;
  width: var(--nxt-hairline);
  height: var(--nxt-hairline);
  margin: calc(var(--nxt-hairline) * -1);
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
</style>
